import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	underOneMinuteText: {
		id: 'autodev.common.time-elapsed.under-one-minute-text',
		defaultMessage: 'Just now',
		description: 'A text to indicate the last data fetch time was under a minute.',
	},
	overOneMinuteText: {
		id: 'autodev.common.time-elapsed.over-one-minute-text',
		defaultMessage: '{date}',
		description: 'A text to indicate the last data fetch time was over a minute.',
	},
	download: {
		id: 'issue.views.issue-base.content.attachment.grid-view.download',
		defaultMessage: 'Download',
		description: 'Label for download button in attachment grid view.',
	},
	delete: {
		id: 'issue.views.issue-base.content.attachment.grid-view.delete',
		defaultMessage: 'Delete',
		description: 'Label for delete button in attachment grid view.',
	},
});
